import apiClient from './client';
import { User } from '@/types';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthResponse {
  token: string;
  data?: {
    id?: string;
    username?: string;
    name?: string;
    email?: string;
    roles?: string[];
  };
}

export interface ForgotPasswordPayload {
  email: string;
}

export interface ResetPasswordPayload {
  token: string;
  password: string;
  passwordConfirmation?: string;
}

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    console.log('[authApi] Calling /api/login');
    const response = await apiClient.post('/api/login', credentials);
    console.log('[authApi] /api/login response:', response.data);
    return response.data;
  },

  logout: async (): Promise<void> => {
    localStorage.removeItem('token');
  },

  getCurrentUser: async (email?: string): Promise<User> => {
    // If email is provided, use the alternative endpoint
    if (email) {
      try {
        console.log('[authApi] Fetching user data for email:', email);
        console.log('[authApi] Token in storage:', !!localStorage.getItem('token'));
        const response = await apiClient.get('/api/user-x.json', {
          params: { email }
        });
        console.log('[authApi] User API response:', response.data);
        
        return {
          id: response.data.email,
          username: response.data.email,
          email: response.data.email,
          name: response.data.nama || response.data.name || email,
          phone: response.data.phone ?? response.data.telepon ?? null,
          address: response.data.address ?? response.data.alamat ?? null,
          roles: response.data.role || response.data.roles || ['ROLE_USER'],
          isActive: response.data.active ?? true,
        };
      } catch (error: any) {
        console.error('[authApi] Failed to fetch user data:', error.response?.status, error.response?.data);
        throw error;
      }
    }
    
    // Try to get from token endpoint (may not work if not implemented)
    throw new Error('No email provided');
  },

  refreshToken: async (): Promise<string> => {
    const response = await apiClient.post('/api/token/refresh');
    return response.data.token;
  },

  requestPasswordReset: async (payload: ForgotPasswordPayload): Promise<{ message: string }> => {
    const response = await apiClient.post('/api/password-reset/request', payload);
    return response.data;
  },

  validatePasswordResetToken: async (token: string): Promise<{ message: string; email?: string; expiresAt?: string }> => {
    const response = await apiClient.get('/api/password-reset/validate', {
      params: { token },
    });

    return response.data;
  },

  resetPassword: async (payload: ResetPasswordPayload): Promise<{ message: string }> => {
    const response = await apiClient.post('/api/password-reset/confirm', payload);
    return response.data;
  },
};
